<template>
  <div style="display: none;"/>
</template>

<script>
  import { getCookie, eraseCookie } from '@Foundation/utilities/cookies';

  export default {
    name: 'prefill-input-value',
    props: {
      newsletterFormParams: { type: Object, default: () => {
        return {
          newsletterEmailCssClass: 'newsletter-email',
          newsletterEmailCookie: 'mdc-newsletter-email',
          registrationSubSourceCssClass: 'registrationSubSource',
          registrationSubSourceCookie: 'In-Page' };
      } },
    },
    data() {
      return {
        isNewsletterEmailCssClass: false,
        isRegistrationSubSourceCssClass: false
      };
    },
    mounted() {
      const isNewsletterEmailClassOnForm = document.getElementsByClassName(this.newsletterFormParams.newsletterEmailCssClass).length || document.querySelector('input[type="email"]');
      this.preFillNewsletterEmail(isNewsletterEmailClassOnForm);
      this.preFillRegistrationSubSource();
        let submitForm = document.querySelector(".main-form__left.sitecore-form-fields form div.form-btn-wrapper input[type='submit']")
        submitForm.addEventListener('click', () => {
          if($("form").valid()) {
            let brand_selected = "";
            let checkbox = $('form .subscribe_check label input[type=checkbox]');
            if(checkbox.prop('checked')){
              let brand = pageData.brand;
              if(brand == 'MUP'){
                brand_selected +='makeup';
              }else if (brand =='SDC'){
                brand_selected +='skincare'
              }
            }
            $("form .checkbox-custom.inline-style.mt30 label input").each(function(){
                if ($(this).is(':checked')) {
                  if(brand_selected == ''){
                    brand_selected += $(this).parent().text().trim();
                  }else{
                    brand_selected += "::"+ $(this).parent().text().trim();
                  }  
                }
            });
            let brands = brand_selected.toLowerCase();
                  const taggingEvent = {
                  event: 'uaevent',
                  ecommerce: undefined,
                  eventCategory:'registration',
                  eventAction: 'newsletter',
                  eventLabel:'header',
                  event_name:'newsletter_registration',
                  referral:'header',
                  selected_brand:brands
                };
                window.dataLayer.push(taggingEvent);
            } 
      })
    },
    methods: {
      preFillNewsletterEmail(isNewsletterEmail) {
        if (isNewsletterEmail) {
          this.isNewsletterEmailCssClass = true;
          /* istanbul ignore next */
          if (getCookie(this.newsletterFormParams.newsletterEmailCookie)) {
            const target = document.querySelector(`.${this.newsletterFormParams.newsletterEmailCssClass}`) || document.querySelector('input[type="email"]');
            target.value =  getCookie(this.newsletterFormParams.newsletterEmailCookie);
            eraseCookie(this.newsletterFormParams.newsletterEmailCookie);
          }
        }
      },

      preFillRegistrationSubSource() {
        /* istanbul ignore next */
        if (getCookie(this.newsletterFormParams.registrationSubSourceCookie)) {
          const newsletterSource = document.querySelector(`.${this.newsletterFormParams.registrationSubSourceCssClass}`);
          newsletterSource.value = getCookie(this.newsletterFormParams.registrationSubSourceCookie);
          eraseCookie(this.newsletterFormParams.registrationSubSourceCookie);
        }
      }
    }
  };
</script>
